<template>
  <section class="has-text-default mt-40 mx-20">
    <div class="level">
      <div class="level-left">
        <div class="level-item mr-20">
          <a @click="$router.push({ name: 'tableau-de-bord' })">
            <b-icon icon="chevron-left" type="is-default"></b-icon>
            <span class="has-text-grid-1 has-text-weight-bold is-size-4 ml-10">
              {{$t('listeClient.titlePage')}}
            </span>
          </a>
        </div>
      </div>
      <div class="level-right">
        <button
          class="button is-info has-text-weight-bold"
          :disabled="isLoad"
          @click="openPopUpSociete(config.POINT_VENTE)">
          <b-icon icon="plus-circle-outline"></b-icon>
          <span>{{$t('listeClient.btnCreate')}}</span>
        </button>
      </div>
    </div>

    <b-table
      :data="liste"
      mobile-cards
      paginated
      :per-page="perPage"
      :current-page.sync="currentPage"
      :loading="isLoad"
      class="no_level">
      <template>
        <b-table-column
          v-for="column in columns"
          :key="column.num"
          v-bind="column"
          header-class="is-size-7 has-text-grid-1 pa-20 has-text-weight-bold"
          cell-class="is-size-7 has-text-default has-text-middle px-20">
          <template #searchable="props">
            <b-select
              v-model="myFilter[props.column.field]"
              v-if="column.field === 'typologie'"
              :placeholder="$t('general.placeolderSearch')"
              expanded
              @input="getList"
            >
              <option value="">{{ $t("general.aucun") }}</option>
              <option
                v-for="(type, i) in config.TYPOLOGIE"
                :key="i"
                :value="type.value">
                {{ getType(type) }}
              </option>
            </b-select>
            <b-select
              v-model="myFilter[props.column.field]"
              v-else-if="column.field === 'societeId'"
              :placeholder="$t('general.placeolderSearch')"
              expanded
              @input="getList"
              >
              <option
                v-for="(societe, i) in societes"
                :key="i"
                :value="societe.id">
                {{ societe.libelle }}
              </option>
            </b-select>
            <b-input
              v-else
              v-model="myFilter[props.column.field]"
              :placeholder="$t('general.placeolderSearch')"
              icon="magnify"
              @keyup.native="actionkeyUp"
              @keydown.native="actionkeyDown"/>
          </template>
          <template v-slot="props">
            <div v-if="column.field === 'nomCommercial' && !column.action">
              <div class="media media-align-center">
                <figure class="media-left">
                  <img
                    height="30"
                    width="30"
                    :src="getImg(props.row.urlLogo)"/>
                </figure>
                <div class="media-content">
                  {{ props.row.nomCommercial }}
                </div>
              </div>
            </div>
            <div v-else-if="column.field === 'societeId' && !column.action">
              {{ getLibellSociete(props.row.societeId) }}
            </div>
            <div v-else-if="column.action">
              <a @click="actionColumnAction(column.field, props)">
                <b-icon :icon="column.icon" type="is-default"></b-icon>
              </a>
            </div>
            <div v-else>
              {{ props.row[column.field] }}
            </div>
          </template>
        </b-table-column>
      </template>

      <template slot="empty">
        <section class="section">
          <div class="content has-text-grey has-text-centered">
            <p>{{$t('tableauDeBord.listeRecom.empty')}}</p>
          </div>
        </section>
      </template>
    </b-table>
    <div class="level" v-if="liste.length">
      <div class="level-left"></div>
      <div class="level-right">
        <div class="level-item is-size-7 has-text-default">
          {{ $t('tableauDeBord.listeRecom.libelPerPage') }}
        </div>
        <div class="level-item">
          <b-select
            placeholder="10"
            class="is-primary"
            v-model="perPage"
            @input="onPageChange(currentPage)">
            <option
              v-for="value in listePerPageValue"
              :key="value"
              :value="value">
              {{ value }}
            </option>
          </b-select>
        </div>
        <div class="level-item">
          <b-pagination
            :total="total"
            :current.sync="currentPage"
            order="is-centered"
            :per-page="perPage"
            @change="onPageChange">
          </b-pagination>
        </div>
      </div>
    </div>

    <b-modal v-model="openPopUp"
      has-modal-card>
      <modal-selection-societe
        @isSelected="creerClient"
      />
    </b-modal>
    <creerClient
      v-if="creerClientActive"
      @close="creerClientActive = false"
      :typeClient="typeClient"/>
  </section>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { browseClients } from '@/api/clients/index.js';
import creerClient from '@/views/client/creerClient.vue';
import { getImg, gestionDev } from '@/services/general/general';
import * as config from '@/configuration/clientConf';
import gestionErreur from '@/services/general/gestionErreur';
import { RESET_STATE } from '@/store/mutation-type'
import modalSelectionSociete from '@/components/general/modalSelectionSociete.vue';
import getSocieteDefautUtilisateur from '@/services/societe/getSocieteDefautUtilisateur';

const Client = createNamespacedHelpers('client');
const Societe = createNamespacedHelpers('societe');
const User = createNamespacedHelpers('user');

export default {
  components: {
    creerClient,
    modalSelectionSociete,
  },
  data() {
    return {
      creerClientActive: false,
      isLoad: false,
      perPage: 10,
      currentPage: 1,
      listePerPageValue: [5, 10, 20, 30, 40, 50],
      liste: [],
      total: null,
      typeClient: '',
      config,
      myFilter: {
        nomCommercial: '',
        typologie: '',
        adresse: '',
        telephone: '',
        email: '',
        societeId: null,
      },
      columns: [
        {
          field: 'nomCommercial',
          label: this.$t('listeClient.liste.table.colonneClient'),
          searchable: true,
        },
        {
          field: 'typologie',
          label: this.$t('listeClient.liste.table.colonneType'),
          searchable: true,
        },
        {
          field: 'adresse',
          label: this.$t('listeClient.liste.table.colonneAdresse'),
          searchable: true,
        },
        {
          field: 'telephone',
          label: this.$t('listeClient.liste.table.colonneTelephone'),
          searchable: true,
        },
        {
          field: 'email',
          label: this.$t('listeClient.liste.table.colonneEmail'),
          searchable: true,
        },
        {
          field: 'societeId',
          label: this.$t('listeClient.liste.table.colonneSociete'),
          searchable: true,
        },
        {
          field: 'detail',
          label: this.$t('listeClient.liste.table.colonneDetail'),
          searchable: false,
          icon: 'file-document',
          action: true,
        },
      ],
      typingTimer: null,
      doneTypingInterval: 2000,
      openPopUp: false,
    };
  },
  computed: {
    ...Societe.mapGetters({
      societes: 'societes',
    }),
    ...User.mapGetters({
      user: 'user',
    }),
  },
  methods: {
    ...Client.mapMutations({
      resteStateClient: RESET_STATE,
    }),
    getImg(img) {
      return getImg(img);
    },
    gestionDev() {
      return gestionDev();
    },
    async getList() {
      try {
        this.isLoad = true;
        const query = {
          skip: (this.currentPage - 1) * this.perPage,
          maxResult: this.perPage,
          nomCommercialCompteComptable: this.myFilter.nomCommercial ? this.myFilter.nomCommercial : '',
          typologie: this.myFilter.typologie ? this.myFilter.typologie : '',
          adressePostaleAA: this.myFilter.adresse ? this.myFilter.adresse : '',
          telephone: this.myFilter.telephone ? this.myFilter.telephone : '',
          email: this.myFilter.email ? this.myFilter.email : '',
          societeId: this.myFilter.societeId,
          type: config.TYPE_CLIENT,
          sousType: config.SOUS_TYPE_AUCUN
        };
        const response = await browseClients('', query);
        this.total = response.totalCount;
        this.liste = response.data;
        this.isLoad = false;
      } catch (error) {
        this.isLoad = false;
        gestionErreur('Erreur lors de la récupération des clients', error);
      }
    },
    creerClient() {
      this.openPopUp = false;
      this.resteStateClient();
      this.creerClientActive = !this.creerClientActive;
    },
    openPopUpSociete(type) {
      this.openPopUp = true;
      this.typeClient = type;
    },
    getType(type) {
      if (type) return this.$t(`listeClient.liste.typeClient.${type.libelle}`);
      return '';
    },
    actionColumnAction(column, props) {
      if (column === 'detail') {
        this.$router.push({
          name: 'detail-client',
          params: {
            type: props.row.typologie,
            id: props.row.num,
          },
        });
      }
    },
    onPageChange(page) {
      this.currentPage = page;
      this.getList();
    },
    actionkeyUp() {
      clearTimeout(this.typingTimer);
      this.typingTimer = setTimeout(this.getList, this.doneTypingInterval);
    },
    actionkeyDown() {
      clearTimeout(this.typingTimer);
    },
    getLibellSociete(societeId) {
      const result =  this.societes.find(s => s.id === societeId);
      return result ? result.libelle : '';
    },
  },
  async mounted() {
    this.myFilter.societeId = getSocieteDefautUtilisateur(this.societes, this.user);
    await this.getList();
  },
};
</script>

<style>
</style>
